import { Box } from '@mui/joy'
import { Chip } from './styled'

type ChipListProps = {
  items: string[]
}

export function ColumnChipList({ items = [] }: ChipListProps) {
  return (
    <Box>
      {items.map((role, index) => (
        <Chip key={`${role}_${index}`}>{role}</Chip>
      ))}
    </Box>
  )
}
